/** โหมด `enrol` (D-156 S-05): login สำเร็จพร้อมธง — panel MFA ใช้แสดงคำแนะนำ (ในหน่วยความจำเท่านั้น) */

let suggested = false;

export function markMfaEnrolmentSuggested(): void {
  suggested = true;
}

export function isMfaEnrolmentSuggested(): boolean {
  return suggested;
}

export function clearMfaEnrolmentSuggested(): void {
  suggested = false;
}
